import React from "react";
import ReactDOM from "react-dom/client";
import "leaflet/dist/leaflet.css";
import "./index.scss";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { HelmetProvider } from "react-helmet-async";
import store from "./redux/store";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { ThemeProvider } from "./context/ThemeContext";
import { GoogleOAuthProvider } from "@react-oauth/google";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  ArcElement,
  Title,
  Tooltip,
  Legend,
  Filler,
} from "chart.js";

// Register ChartJS components
ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  ArcElement,
  Title,
  Tooltip,
  Legend,
  Filler,
);

const rootElement = document.getElementById("root");
const GOOGLE_CLIENT_ID =
  "307747641571-davq6uj8ujimnu175s8tk8ede1jh57vp.apps.googleusercontent.com";
// Support for react-snap pre-rendering
if (rootElement.hasChildNodes()) {
  ReactDOM.hydrateRoot(
    rootElement,
    <HelmetProvider>
      <ThemeProvider>
        <Provider store={store}>
          <BrowserRouter>
            <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
              {/* Single sonner <Toaster /> lives inside App so every toast
                call across the tree uses one library + one design. */}
              <App />
            </GoogleOAuthProvider>
          </BrowserRouter>
        </Provider>
      </ThemeProvider>
    </HelmetProvider>,
  );
} else {
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <HelmetProvider>
      <ThemeProvider>
        <Provider store={store}>
          <BrowserRouter>
            <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
              {/* Single sonner <Toaster /> lives inside App so every toast
                call across the tree uses one library + one design. */}
              <App />
            </GoogleOAuthProvider>
          </BrowserRouter>
        </Provider>
      </ThemeProvider>
    </HelmetProvider>,
  );
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
